import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { FormButton } from 'common';
import 'forms/styles/commonForm.scss';
import './factorSelectionForm.scss';

const FactorSelectionForm = ({ factors, send }) => {
  const requiredFields = ['type', 'key'];
  const [factor, setFactor] = useState();
  const onChange = (factorType, key) => {
    setFactor({ type: factorType, key: key });
  };
  return (
    <div className="occu-form">
      <Form
        onSubmit={(event) => {
          send(factor);
          event.preventDefault();
        }}
      >
        <h5>
          For security purposes, we need to verify it's you. Please choose a method to receive your one time passcode.
          Data rates may apply.
        </h5>
        <Form.Group>
          <FactorsFragment
            title="Text Message"
            factors={factors.sms || factors.SMS}
            onChange={(key) => onChange('sms', key)}
          />
        </Form.Group>
        <Form.Group>
          <FactorsFragment
            title="Voice Call"
            factors={factors.call || factors.Call}
            onChange={(key) => onChange('call', key)}
          />
        </Form.Group>
        <Form.Group>
          <FactorsFragment
            title="Email"
            factors={factors.email || factors.Email}
            onChange={(key) => onChange('email', key)}
          />
        </Form.Group>
        <FormButton requiredFields={requiredFields} submittedFields={factor}>
          Continue
        </FormButton>
      </Form>
    </div>
  );
};

const FactorsFragment = ({ title, factors, onChange }) => {
  const h5Style = { textDecoration: 'underline', textAlign: 'left' };
  if (!factors) return null;
  const factorArray = Object.entries(factors).filter(
    ([key, value]) => value !== null
  );
  return (
    <>
      {factorArray.length > 0 && <h5 style={h5Style}>{title}:</h5>}
      {factorArray.map(([key, value]) => (
        <Form.Check
          key={key}
          type={'radio'}
          label={value}
          name="factors"
          value={value}
          onChange={() => onChange(key)}
        />
      ))}
    </>
  );
};

export { FactorSelectionForm };
